export enum CardStatus {
  Valid = 'Valid',
  ExpiringSoon = 'ExpiringSoon',
  Expired = 'Expired',
}
